import { trans } from "@mongez/localization";
import aboutNannisImage from "app/assets/images/about-us/about-nannis.png";

export function AboutNannisCakes() {
  return (
    <section className="container grid grid-cols-1 gap-20 lg:items-center xl:grid-cols-2">
      <div className="flex flex-1 items-center justify-center">
        <img
          src={aboutNannisImage}
          alt="About Nannis"
          className="rounded-4xl object-cover"
          width={780}
          height={600}
        />
      </div>
      <div className="flex flex-col gap-6 lg:mt-0">
        <h4 className="text-2xl leading-[140%] font-bold lg:text-3xl">
          <span className="text-primary-800 text-[3rem] lg:text-[5rem]">
            {trans("aboutUsPage.atNannisCakes")}
          </span>{" "}
          <span className="text-xl leading-tight lg:text-2xl">
            {trans("aboutUsPage.believeIngredients")}
          </span>
        </h4>
        <p className="font-avenir text-night text-xl leading-tight lg:text-2xl">
          {trans("aboutUsPage.ourJourney")}
        </p>
        <p className="font-avenir text-night text-xl leading-tight lg:text-2xl">
          {trans("aboutUsPage.classicFavorites")}
        </p>
      </div>
    </section>
  );
}
